import React, { createContext, useState, useContext, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [agent, setAgent] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user is already logged in
    const storedAgent = localStorage.getItem('agent');
    if (storedAgent && token) {
      try {
        setAgent(JSON.parse(storedAgent));
      } catch (error) {
        console.error('Error parsing stored agent:', error);
        localStorage.removeItem('agent');
        localStorage.removeItem('token');
      }
    }
    setLoading(false);
  }, [token]);

  const login = async (googleToken) => {
    try {
      const response = await authAPI.googleLogin(googleToken);
      const { token: newToken, agent: agentData } = response.data;

      setToken(newToken);
      setAgent(agentData);
      localStorage.setItem('token', newToken);
      localStorage.setItem('agent', JSON.stringify(agentData));

      return { success: true };
    } catch (error) {
      console.error('Login error:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Login failed',
      };
    }
  };

  const logout = () => {
    setToken(null);
    setAgent(null);
    localStorage.removeItem('token');
    localStorage.removeItem('agent');
  };

  const isAdmin = () => {
    return agent?.role === 'admin';
  };

  const isAgent = () => {
    return agent?.role === 'agent';
  };

  const value = {
    agent,
    token,
    loading,
    login,
    logout,
    isAdmin,
    isAgent,
    isAuthenticated: !!token && !!agent,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};


